import { render, staticRenderFns } from "./datatrend.vue?vue&type=template&id=5150a213&scoped=true&"
import script from "./datatrend.vue?vue&type=script&lang=js&"
export * from "./datatrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150a213",
  null
  
)

export default component.exports